import React from 'react'
import {Controller, useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import InputPassword from '../InputPassword'

const FormInputPassword = ({
    name,
    rules,
    label,
    required,
    type,
    i18nCategory,
    defaultValue,
    variant,
    readOnly,
    error,
}) => {
    const {control} = useFormContext()
    const {t} = useTranslation()
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({field: {onChange}}) => (
                <InputPassword
                    onChange={onChange}
                    defaultValue={defaultValue ?? null}
                    label={t(`${i18nCategory}.${label}`)}
                    required={required}
                    disabled={readOnly}
                    type={type}
                    variant={variant}
                    error={!!error}
                    helperText={error?.message && t(`error.${error.message}`)}
                />
            )}
        />
    )
}

export default FormInputPassword
